import {AudienceParams} from '../types/records-table.types';

export function getDefaultAudienceParams(): AudienceParams {
  return {
    age: [
      { name: '1317', all: null, men: null, women: null },
      { name: '1824', all: null, men: null, women: null },
      { name: '2534', all: null, men: null, women: null },
      { name: '3544', all: null, men: null, women: null },
      { name: '4554', all: null, men: null, women: null },
      { name: '5564', all: null, men: null, women: null },
      { name: '65', all: null, men: null, women: null },
    ],
    geo: [
      { name: 'ru', value: null },
      { name: 'br', value: null },
      { name: 'kz', value: null },
      { name: 'ua', value: null },
      { name: 'other', value: null },
    ]
  }
}
